<template>
	<el-container class="layout-container" style="height: 100vh;">
		<!-- 顶栏 -->
		<el-header style="padding: 0; background-color: #fff;">

			<MainNavbar />
		</el-header>

		<el-container class="layout-body">
			<!-- 左侧菜单 -->
			<el-aside width="200px" style="background-color: #fff;">
				<SideBar />
			</el-aside>

			<!-- 主内容区 -->
			<el-main style="padding: 20px; background-color: #f5f7fa;">
				<div class="breadcrumb-static-container">
					<span class="breadcrumb-separator">/</span>
					<span v-if="$route.meta.group" class="breadcrumb-item">
						{{ $route.meta.group }}
						<span class="breadcrumb-separator">/</span>
					</span>
					<span class="breadcrumb-item is-current">
						{{ $route.meta.title }}
					</span>
				</div>
				<router-view />
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
	import MainNavbar from './MainNavbar.vue'
	import SideBar from './SideBar.vue'

	export default {
		name: 'MainLayou',
		components: {
			MainNavbar,
			SideBar
		}

	}
</script>

<style scoped>
	.layout-container {
		height: 100vh;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	.layout-body {
		flex: 1;
		min-height: 0;
		overflow: hidden;
	}

	.el-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: #fff;
		font-size: 18px;
		font-weight: bold;
	}

	.el-aside {
		border-right: 1px solid #dcdfe6;
		overflow-y: auto;
		overflow-x: hidden;
	}

	.el-main {
		overflow-y: auto;
		overflow-x: hidden;
	}

	.breadcrumb-static-container {
		display: flex;
		align-items: center;
		padding-bottom: 16px;
		font-size: 14px;
		color: #1D2129;
		white-space: nowrap;
	}

	.breadcrumb-item {
		margin: 0 4px;
		transition: color 0.3s;
	}

	.breadcrumb-item.is-current {
		color: #1d2129;
		font-weight: 600;
	}
</style>
